export default "__VITE_ASSET__Dwj38kVi__"